import { serialize } from "object-to-formdata";
import CryptoJS from 'crypto-js';

export const convertJsonToFormData = (data) => {
  const formData = serialize(data, { indices: true });

  return formData;
};

export const convertFormatedDate = (isoDateString) => {
  const date = new Date(isoDateString); // Convert the ISO string to a Date object

  // Extract day
  const day = date.getUTCDate().toString().padStart(2, '0');

  // Extract month name
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getUTCMonth()];

  // Extract hours and minutes
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  // Determine AM or PM suffix
  const ampm = hours >= 12 ? 'pm' : 'am';

  // Convert 24-hour format to 12-hour format
  hours = hours % 12 || 12; // Converts '0' to '12' for midnight case

  // Return formatted date string
  return `${day} ${month} ${hours}:${minutes}${ampm}`;
};


export const encryptValue = (value) => {

  const secretKey = process.env.REACT_APP_HASHKEY;
  const encryptedValue = CryptoJS.AES.encrypt(value.toString(), secretKey).toString();
  return encryptedValue;
};

export const decryptValue = (encryptedValue) => {
  const secretKey = process.env.REACT_APP_HASHKEY;
  const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
};

export const formatTimeAgo = (timestamp) => {
  const currentTime = new Date();
  const givenTime = new Date(timestamp);

  // Calculate the difference in seconds
  const timeDifference = Math.floor((currentTime - givenTime) / 1000); // Time difference in seconds

  if (timeDifference < 60) {
    return `${timeDifference} seconds ago`;
  }

  const minutesDifference = Math.floor(timeDifference / 60);
  if (minutesDifference < 60) {
    return `${minutesDifference} minutes ago`;
  }

  const hoursDifference = Math.floor(minutesDifference / 60);
  if (hoursDifference < 24) {
    return `${hoursDifference} hours ago`;
  }

  const daysDifference = Math.floor(hoursDifference / 24);
  if (daysDifference < 7) {
    return `${daysDifference} days ago`;
  }

  const weeksDifference = Math.floor(daysDifference / 7);
  if (weeksDifference < 4) {
    return `${weeksDifference} weeks ago`;
  }

  const monthsDifference = Math.floor(daysDifference / 30); // Approximation for months
  if (monthsDifference < 12) {
    return `${monthsDifference} months ago`;
  }

  const yearsDifference = Math.floor(daysDifference / 365);
  return `${yearsDifference} years ago`;
};

export const calculateCompletionPercentage = (completedStream) => {
  
  const timeParts = completedStream.split(':').map(Number);

  let hours, minutes, seconds;

  if (timeParts.length === 2) {
    [minutes, seconds] = timeParts;
    hours = 0;
  } else if (timeParts.length === 3) {
    [hours, minutes, seconds] = timeParts;
  } else {
    return 0;
  }
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;

  const totalDurationInSeconds = 3600;

  const percentage = (totalSeconds / totalDurationInSeconds) * 100;

  return percentage.toFixed(2); 
};


// export const formatDate = (timestamp) => {
//   const options = {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//       hour12: true, // Set to true for 12-hour format, false for 24-hour format
//   };
//   return new Date(timestamp).toLocaleDateString(undefined, options);
// };
